import * as actionTypes from "./../../Constants/locations/locationActionTypes";
import API from "./../../Constants/locations/API";
import * as locationServices from "../../services/locations/index";

export const newLocations = (locationData, request) => ({
    type: actionTypes.SAVE_EDITS,
    payload: { locationData: [...locationData, ...request]
    }
})

export function saveEdits (loc, allLocations) {
    return async dispatch => {        
        const request = await locationServices.req.setAllLocations(API.saveAllLocations, loc)
        return dispatch({
            type: actionTypes.ADD_NEW_LOCATION,
            payload: { request }
        });
    };
}
